import { toast } from 'react-toastify';

// descarca cea mai recenta cerere a studentului (pentru profesor)
export const descarcaCerere = (student) => {
    fetch(`${process.env.REACT_APP_SERVER}cerere/${student.id}`, {
        method: 'GET',
        headers: {
            Authorization: localStorage.getItem('token'),
            'Content-Type': 'application/json',
        },
    })
        .then(res => res.json())
        .then(data => {
            if (!data?.fisier) {
                toast.error('Nu există fișier încărcat!');
                return;
            }
            const downloadLink = document.createElement('a');
            downloadLink.href = data.fisier;
            downloadLink.download = `Cerere licență ${student.nume + ' ' + student.prenume} - ${data.titlu}.pdf`;
            downloadLink.click();
        })
        .catch(() => toast.error('Cererea nu a putut fi descărcată!'));
};

// cea mai recenta cerere din lista (lista vine ordonata crescator de la server)
export const ultimaCerere = (student) =>
    student.Cereris && student.Cereris.length > 0 ? student.Cereris[student.Cereris.length - 1] : null;
